import type { ISkillData } from '../types';
import type { ISelectedSkillTagData } from '../../components/QAInput/SkillMention/SelectedSkillTag';
import { getSkillDisplayName } from './display';

/**
 * 根据 tag 数据从列表中解析完整 Skill
 * @param tag - 选中 Skill tag
 * @param allSkills - 全量 Skill 列表
 */
export const resolveSkillFromTag = (
  tag: Pick<ISelectedSkillTagData, 'skillId' | 'name'>,
  allSkills: ISkillData[],
): ISkillData | undefined => {
  const skillId = tag.skillId?.trim();
  if (skillId) {
    return allSkills.find((item) => item.skill_id === skillId);
  }
  const skillName = tag.name?.trim();
  if (skillName) {
    return allSkills.find((item) => item.skill_name === skillName);
  }
  return undefined;
};

/**
 * 构造与 SkillMention 选中 skill 一致的 tag 结构
 * @param skill - Skill 原始数据
 * @param isEN - 是否英文环境
 */
export const buildSelectedSkillTag = (
  skill: ISkillData,
  isEN: boolean,
): ISelectedSkillTagData => ({
  skillId: skill.skill_id,
  name: skill.skill_name,
  display_name_cn: skill.display_name_cn,
  display_name_en: skill.display_name_en,
  icon: skill.category_icon || '',
  type: 'queryTabs',
  displayName: getSkillDisplayName(skill, isEN),
});
